import { TYPE_FOLD_COLOR } from '../leave-dashboard/constants';

// Ekibimin İzinleri — saf hesaplar (tarayıcı saat diliminden bağımsız: tüm gün hesapları UTC ile). Sunucu tarihleri
// yerel gün olarak "yyyy-MM-dd", ayları "yyyy-MM" verir; endDate izinli son gündür (dahil).

// Türü gizli (yönetici / ekip arkadaşı) satırların tek nötr rengi.
export const HIDDEN_TYPE_COLOR = '#6B7FA3';

const DAY_MS = 24 * 60 * 60 * 1000;
const pad = (n) => String(n).padStart(2, '0');

export function monthKey(year, month) {
  return `${year}-${pad(month)}`;
}

export function parseMonthKey(key) {
  const [year, month] = String(key).split('-').map(Number);
  return { year, month };
}

const monthIndex = (key) => {
  const { year, month } = parseMonthKey(key);
  return year * 12 + (month - 1);
};

const fromIndex = (index) => monthKey(Math.floor(index / 12), (index % 12) + 1);

export function monthOptions(firstMonth, lastMonth) {
  const out = [];
  for (let i = monthIndex(firstMonth); i <= monthIndex(lastMonth); i += 1) {
    const key = fromIndex(i);
    out.push({ key, ...parseMonthKey(key) });
  }
  return out;
}

export function shiftMonth(key, delta, firstMonth, lastMonth) {
  const next = monthIndex(key) + delta;
  if (next < monthIndex(firstMonth) || next > monthIndex(lastMonth)) return null;
  return fromIndex(next);
}

export function daysInMonth(year, month) {
  return new Date(Date.UTC(year, month, 0)).getUTCDate();
}

export function weekBands(year, month) {
  const days = daysInMonth(year, month);
  const bands = [];
  for (let start = 1; start <= days; start += 7) {
    const end = Math.min(start + 6, days);
    bands.push({ label: `${start}–${end}`, startDay: start, endDay: end });
  }
  return bands;
}

const dayNumber = (iso) => {
  const [y, m, d] = String(iso).split('-').map(Number);
  return Date.UTC(y, m - 1, d) / DAY_MS;
};

// Ayın içindeki yüzde konumu. Ay dışına taşan izin kırpılır; saatlik izin tek gündür. Kesişme yoksa null.
export function barGeometry(entry, year, month) {
  const total = daysInMonth(year, month);
  const monthStart = Date.UTC(year, month - 1, 1) / DAY_MS;
  const first = dayNumber(entry.startDate);
  const last = entry.isHourly ? first : dayNumber(entry.endDate || entry.startDate);
  const from = Math.max(first, monthStart);
  const to = Math.min(last, monthStart + total - 1);
  if (to < from) return null;
  return { left: ((from - monthStart) / total) * 100, width: ((to - from + 1) / total) * 100 };
}

// Bugünün sütununun BAŞI (yüzde); bugün bu ayda değilse null.
export function todayOffset(today, year, month) {
  if (!today) return null;
  const total = daysInMonth(year, month);
  const offset = dayNumber(today) - Date.UTC(year, month - 1, 1) / DAY_MS;
  if (offset < 0 || offset >= total) return null;
  return (offset / total) * 100;
}

export function entryColor(entry, canSeeType, typeColors) {
  if (!canSeeType) return HIDDEN_TYPE_COLOR;
  return typeColors.get(entry.leaveVariationId) || TYPE_FOLD_COLOR;
}
